import React from 'react';
import '../assets/styles/global.sass';
import '../assets/styles/components/Phases.sass';
import Top from './Top';
import Footer from './Footer';
import { Helmet } from 'react-helmet'

const Layout = (props) => (
  <>
    <Helmet>
      <title>{props.title ? props.title : 'La Leyenda Series'}</title>
      <meta name="description" content={props.description ? props.description : 'La Leyenda Series, Eventos de 1 día de MTB Maraton en Colombia para aficionados de todos los niveles. Compite contra los mejores corredores aficionados en una ruta desafiante o disfruta de una travesía más tranquila y corta. Actividades y pista corta disponibles para niños. ¡Trae a toda la familia!'} />
      <meta property="og:title" content={props.title ? props.title : 'La Leyenda Series'} />
      <meta property="og:description" content={props.description ? props.description : 'La Leyenda Series, Eventos de 1 día de MTB Maraton en Colombia para aficionados de todos los niveles. Compite contra los mejores corredores aficionados en una ruta desafiante o disfruta de una travesía más tranquila y corta. Actividades y pista corta disponibles para niños. ¡Trae a toda la familia!'} />
    </Helmet>
    <div className="container-fluid">
      <Top />
      {props.children}
      <Footer />
    </div>
  </>
)

export default Layout;
